<i18n>
[
    "a11y__carousel--slideNumber"
]
</i18n>

<template>
    <div class="c-slider-dots">
        <span
            v-for="(_, index) in pageCount"
            :key="`slider-${name}-marker-${index}`"
            v-tab-focus.onspace="() => changePage(index)"
            :aria-label="t('a11y__carousel--slideNumber', [index + 1])"
            class="c-slider-dots__marker"
        >
            <span
                :aria-current="pageIndex === index"
                class="c-slider-dots__dot"
                :class="{ 'c-slider-dots__dot--current': pageIndex === index }"
            ></span>
        </span>
    </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
    pageCount: {
        type: Number,
        required: true,
    },
    pageIndex: {
        type: Number,
        required: true,
    },
    name: {
        type: String,
        required: true,
    },
});

const { t } = useI18n();

const emit = defineEmits(['changePage']);

function changePage(index) {
    emit('changePage', index);
}
</script>

<style lang="scss">
.c-slider-dots {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    &__marker {
        cursor: pointer;
        padding: $nu-spacer-0pt5;

        &:not(:last-child) {
            margin-right: $nu-spacer-0pt5;
        }
    }

    &__dot {
        display: block;
        border-radius: 100%;
        border: 1px solid $nu-primary;
        height: 8px;
        width: 8px;
        transition: background-color 0.2s ease;

        &--current {
            background-color: $nu-primary;
        }
    }
}
</style>
